import {
  FeedbackModal,
  HigherTierOnlyFeatureModal,
  NoMoreCreditsLeftModal,
  NotificationsModal,
  ProOnlyFeatureModal,
} from '@app-velocity/modules/users';

import { ActionConfirmationModal } from '@app-velocity/ui';

import { PaidTeamAvailableModal } from '@app-velocity/modules/teams';

import { RemoveFigmaReportModal } from '@app-velocity/modules/simulation-report';

import { ShareScenarioModal } from './modals/ShareScenarioModal';
import { RunAnotherSimulationModal } from './modals/RunAnotherSimulationModal';
import { SnapshotWarningsModal } from './modals/SnapshotWarningsModal';

export const AppModalsProtected = () => {
  return (
    <>
      <FeedbackModal />
      <ActionConfirmationModal />
      {/* <AiReviewDetailsModal /> */}
      <ShareScenarioModal />
      <RunAnotherSimulationModal />
      <ProOnlyFeatureModal />
      <NoMoreCreditsLeftModal />
      <HigherTierOnlyFeatureModal />
      <SnapshotWarningsModal />
      <NotificationsModal />
      <PaidTeamAvailableModal />
      <RemoveFigmaReportModal />
    </>
  );
};
